import SettingsPage from 'pages/SettingsPage/SettingsPage';

export default SettingsPage;
